import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Faq from '../../../../components/Faq/faq';
import Banner from '../../../../components/Bannersection/banner';
import { Helmet } from "react-helmet";

function Erp() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          const headerOffset = 250;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }, 300);
      }
    }
  }, [location, location.hash]);

  const pagename = [{ pagetitle: "ERP Solutions", subtitle: "ERP" }];

  const faqitem = [
    { Faq_id: "collapseone", data_bs_target: "#collapseone", question: "Why should my business consider ERP solutions?", answer: "ERP solutions integrate all your business processes into a single system, enhancing operational efficiency, providing real-time data insights, reducing manual errors, and facilitating better decision-making." },
    { Faq_id: "collapsetwo", data_bs_target: "#collapsetwo", question: "What types of ERP services do you offer?", answer: "We offer comprehensive ERP services including Custom ERP Development, Cloud ERP Implementation, ERP Migration, and ERP Support & Maintenance, tailored to your specific industry needs." },
    { Faq_id: "collapseThree", data_bs_target: "#collapseThree", question: "Is ERP suitable for small businesses?", answer: "Absolutely. Modern ERP systems are highly scalable and can be tailored to fit the budget and operational requirements of small businesses, helping them grow efficiently without being weighed down by fragmented tools." },
    { Faq_id: "collapseFour", data_bs_target: "#collapseFour", question: "Can an ERP system integrate with our existing software?", answer: "Yes, our ERP solutions are designed with robust integration capabilities. We can seamlessly connect the new ERP system with your existing third-party applications and legacy software to ensure smooth data flow." },
    { Faq_id: "collapseFive", data_bs_target: "#collapseFive", question: "How long does it take to implement an ERP system?", answer: "The implementation timeline varies based on the complexity of your business processes and the scope of the ERP solution. We work closely with our clients to establish realistic timelines and ensure a smooth, timely rollout." },
  ];

  return (
    <div>
      <Helmet>
        <title>Comprehensive ERP Solutions | DGI Worx Australia</title>
        <meta name="description" content="Transform your business operations with DGI Worx's comprehensive ERP solutions. Integrate processes, improve efficiency, and drive business growth." />
        <meta name="keywords" content="erp solutions, enterprise resource planning, custom erp, cloud erp, erp implementation, erp software, DGi WORX, dgiworx, business automation, australia" />
        <meta property="og:title" content="ERP Solutions | Custom & Cloud ERP Services | DGi WORX Australia" />
        <meta property="og:description" content="Explore DGi WORX's advanced ERP solutions covering custom development, cloud implementation, and system integration. Unify your business processes today." />
        <meta property="og:image" content="/assets/img/dgiworx-home-embedded.jpg" />
        <meta property="og:url" content="https://dgiworx.com.au/erp" />
        <link rel="canonical" href="https://dgiworx.com.au/erp" />
        <link rel="alternate" hreflang="en-au" href="https://dgiworx.com.au/" />
      </Helmet>

      <Banner items={pagename} />
      <h1 className='d-none'>Enterprise Resource Planning Solutions - DGi WORX Australia</h1>

      <section className="about-area tp-about-two py-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="tp-about-two-wrap mt-10 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-about-two-thumb">
                  <div className='tp-about-circle'>
                    <div className='tp-about-circle-two'>
                      <img src="/assets/img/service/erp/01.png" alt="enterprise resource planning solutions" loading='lazy' />
                    </div>
                  </div>
                </div>
                <div className="tp-about-two-thumb-shape tp-thumb-common fix">
                  <div className="tp-thumb-common-overlay wow"></div>
                  <img src="/assets/img/service/automation/02.jpg" alt="" loading='lazy' />
                </div>
                <div className="tp-about-two-thumb-shape-two d-none d-md-block">
                  <img src="/assets/img/about/two/dote.png" alt="" loading='lazy' />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tp-about-two-wrapper mb-10 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-section mb-40">
                  <span className="tp-section-sub-title">Unified Business Operations</span>
                  <h2 className="tp-section-title">ERP SOLUTIONS</h2>
                  <div className="tp-section-title-wrapper">
                    <p>At DGi WORX, we provide cutting-edge Enterprise Resource Planning (ERP) solutions that empower Australian businesses to achieve complete operational transparency and agility. Our services help simplify complex multi-departmental workflows, eliminate data silos, and foster better collaboration. By adopting an integrated ERP system, you can centralise your data while optimising resources from human resources to supply chain management.<br /><br /></p>
                  </div>
                </div>
                <div className="tp-about-two-list">
                  <ul>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Process Integration</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Data Centralisation</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Real-time Reporting</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Enhanced Productivity</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Scalability</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Better Collaboration</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-about-two-shape">
          <div className="tp-about-two-shape-4">
            <img src="/assets/img/about/two/about-2-shape-2.png" alt="" loading='lazy' />
          </div>
        </div>
      </section>

      <section className="feature-area tp-feature-5-wrap py-50">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="tp-section text-center mb-50">
                <span className="tp-section-sub-title">Transformative capabilities</span>
                <h2 className="tp-section-title">Our ERP Services</h2>
                <p>Our solutions are meticulously designed to seamlessly connect every aspect of your enterprise, enhancing data visibility and eliminating workflow bottlenecks.</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="">
              <div className='sub-services mb-50' id="cloud-erp">
                <div className='row align-items-center'>
                  <div className="col-lg-4 col-md-5 col-sm-12">
                    <div className="text-center sub-service-carde mb-20">
                      <div className="sub-service-carde-img tp-thumb-common fix overlay-anim">
                        <div className="corner-border"></div>
                        <img src="/assets/img/service/erp/cloud.png" loading='lazy' style={{ width: '100%', height: '100%', maxHeight: '300px', objectFit: 'cover' }} />
                        <div className="bottom-corner"></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12">
                    <div className="tp-blog-item-content">
                      <div className="tp-blog-item-title sub-service mb-30">
                        <h4>CLOUD ERP IMPLEMENTATION</h4>
                        <p>In today's fast-paced business environment, flexibility and accessibility are crucial. Cloud ERP solutions allow your team to access critical business data from anywhere, on any device. It reduces the overhead costs associated with on-premise hardware and provides automatic, hassle-free updates.<br /><br />We help Australian organisations smoothly transition to web-based, cloud-hosted ERP environments. Through careful planning, data alignment, and tailored deployment strategies, DGi WORX ensures your cloud ERP implementation is seamless and rapidly delivers a high return on investment.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='sub-services mb-50' id="custom-erp">
                <div className='row align-items-center'>
                  <div className="col-lg-4 col-md-5 col-sm-12 order-md-2">
                    <div className="text-center sub-service-carde mb-20">
                      <div className="sub-service-carde-img tp-thumb-common fix overlay-anim">
                        <div className="corner-border"></div>
                        <img src="/assets/img/service/erp/custom.png" loading='lazy' style={{ width: '100%', height: '100%', maxHeight: '300px', objectFit: 'cover' }} />
                        <div className="bottom-corner"></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12 order-md-1">
                    <div className="tp-blog-item-content">
                      <div className="tp-blog-item-title sub-service mb-30">
                        <h4>CUSTOM ERP DEVELOPMENT</h4>
                        <p>Off-the-shelf software often forces businesses to change their unique processes to fit the system. DGi WORX's Custom ERP Development ensures the software bends to your needs, not the other way around. We build tailored modules specifically designed for your industry's intricacies.<br /><br />Our end-to-end custom development life cycle covers requirement gathering, architecture design, module development, and deployment. This customised approach guarantees an intuitive interface for your staff, higher adoption rates, and a system built exactly to support your unique competitive advantages.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='sub-services mb-10' id="erp-integration">
                <div className='row align-items-center'>
                  <div className="col-lg-4 col-md-5 col-sm-12">
                    <div className="text-center sub-service-carde mb-20">
                      <div className="sub-service-carde-img tp-thumb-common fix overlay-anim">
                        <div className="corner-border"></div>
                        <img src="/assets/img/service/erp/integration.png" loading='lazy' style={{ width: '100%', height: '100%', maxHeight: '300px', objectFit: 'cover' }} />
                        <div className="bottom-corner"></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12">
                    <div className="tp-blog-item-content">
                      <div className="tp-blog-item-title sub-service mb-30">
                        <h4>SYSTEM INTEGRATION & MIGRATION</h4>
                        <p>Moving from disconnected legacy systems or older software versions can be daunting. Our ERP Integration and Migration services securely transfer your historical data to the new platform while ensuring seamless communication with your existing third-party applications.<br /><br />With DGi WORX, we employ rigorous data validation and testing protocols to ensure zero data loss and minimal downtime during the transition. We unify your digital ecosystem so that information flows freely across all platforms, providing leadership with a singular, accurate view of the entire organisation's performance in real-time.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Faq items={faqitem} />
    </div>
  );
}

export default Erp;
